import React from 'react';
import Tooltip from '@mui/material/Tooltip'; 

const CustomTooltip = ({ title, className }) => {
    return (
        <Tooltip 
            title={ <p>{title}</p> }
            componentsProps={{
                tooltip: {
                sx: { maxWidth: "600px", fontSize: "14px" },
                },
            }}
            >
            <span className={`text-xl relative ${className}` } style={{ top: "2px" }}> ⓘ </span>
        </Tooltip>
    )
}

export default CustomTooltip;
